import $ from 'jquery';

import BaseController from 'chairisher/_controller';
import BusinessFollowView from 'chairisher/view/business/follow';
import BusinessSearchView from 'chairisher/view/business/search';

import {
    trackCityCollectionRailClick,
    trackDesignerBusinessImpressions,
    trackDesignerContact,
    trackPaginationBottomClick,
    trackPaginationTopClick,
    trackPopularLocationRailClick,
    trackSearchSubmit,
} from 'chairisher/analytics/business/search';
import { getFollowedBusinessIds } from 'chairisher/context/business';
import { getBusinessJson } from 'chairisher/context/search';
import { BusinessSearchPosition } from 'chairisher/util/analytics';
import { toggleDescription } from 'chairisher/util/collapse';
import { observeIntersectionForElsOnce } from 'chairisher/view/helper/intersectionobserver';

/**
 * Controls actions related to the business search view.
 */
class BusinessSearchController extends BaseController {
    /** @inheritDoc */
    initControllerState() {
        super.initControllerState();

        /**
         * SearchView for this controller.
         *
         * @type {BusinessSearchView}
         */
        this.searchView = new BusinessSearchView();
    }

    /** @inheritDoc * */
    bindPageActions() {
        super.bindPageActions();

        this.searchView.bind();

        this.searchView.getSearchForm().on('businessSearch.submit', (e, data) => {
            trackSearchSubmit(data.search);
            window.location = data.url;
        });

        $('.js-description-toggle').on('click', (e) => {
            toggleDescription(e);
        });

        new BusinessFollowView({
            followedBusinessIds: getFollowedBusinessIds(),
        }).bind();
    }

    /** @inheritDoc * */
    bindPageAnalytics() {
        super.bindPageAnalytics();

        $('.js-product-rail a').on('click', trackCityCollectionRailClick);
        $('.js-contact-designer').on('click', (e) => {
            e.preventDefault();
            trackDesignerContact(e, $(e.currentTarget).data('href'));
        });
        $('.js-business-dma-list a').on('click', trackPopularLocationRailClick);
        $('.js-pagination-numbered:eq(0) a').on('click', trackPaginationTopClick);
        $('.js-pagination-numbered:eq(1) a').on('click', trackPaginationBottomClick);
        observeIntersectionForElsOnce($('.js-business'), (entry) => {
            const idx = entry.target.attributes['data-business-id'].value;
            const businessJson = getBusinessJson();
            if (idx in businessJson) {
                const businessInformation = businessJson[idx];
                trackDesignerBusinessImpressions(
                    BusinessSearchPosition.DESIGNER_DIRECTORY,
                    businessInformation.is_dma_match,
                    businessInformation.absolute_url,
                );
            }
        });
    }
}

export default BusinessSearchController;
